export const ONE_WAY = [
  'token-hashing', 'multi-cluster-management'
];

export const HARVESTER_NAME = 'harvester';
export const SCHEDULING_CUSTOMIZATION = 'cluster-agent-scheduling-customization';
export const IMPORTED_DAY_2_OPS = 'imported-day-2-ops';
